import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOnboarding } from '../contexts/OnboardingContext';
import './OnboardingTooltip.css';

const OnboardingTooltip = ({ 
  stepId, 
  title, 
  description, 
  position = 'bottom',
  showSkip = true,
  onAction = null,
  waitForAction = false,
  actionText = null
}) => {
  const { t } = useTranslation();
  const { isStepActive, completeStep, skipOnboarding } = useOnboarding();

  // Debug information for onboarding step
  
  if (!isStepActive(stepId)) {
    return null;
  }

  const handleNext = () => {
    if (onAction) {
      onAction();
    }
    completeStep(stepId);
  };

  const handleSkip = () => {
    skipOnboarding();
  };

  const getPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'onboarding-tooltip-top';
      case 'bottom':
        return 'onboarding-tooltip-bottom';
      case 'left':
        return 'onboarding-tooltip-left';
      case 'right':
        return 'onboarding-tooltip-right';
      default:
        return 'onboarding-tooltip-bottom';
    }
  };

  return (
    <div className={`onboarding-tooltip ${getPositionClasses()}`}>
      <div className="onboarding-tooltip-content">
        <div className="onboarding-tooltip-header">
          <h4 className="onboarding-tooltip-title">{title}</h4>
          {showSkip && (
            <button 
              className="onboarding-tooltip-skip"
              onClick={handleSkip}
              title={t('onboarding.skip')}
            >
              ×
            </button>
          )}
        </div>
        <p className="onboarding-tooltip-description">{description}</p>
        
        {actionText && (
          <div className="onboarding-tooltip-action">
            <strong>👆 {actionText}</strong>
          </div>
        )}
        
        {!waitForAction && (
          <div className="onboarding-tooltip-actions">
            <button 
              className="onboarding-tooltip-next btn btn-primary btn-sm"
              onClick={handleNext}
            >
              {t('onboarding.gotIt', 'Got it!')}
            </button>
          </div>
        )}
        {waitForAction && (
          <div className="onboarding-tooltip-waiting">
            <div className="spinner-border spinner-border-sm me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="text-muted">{t('onboarding.waitingForAction', 'Waiting for your action...')}</span>
          </div>
        )}
      </div>
      <div className="onboarding-tooltip-arrow"></div>
    </div>
  );
};

export default OnboardingTooltip;
